import React from 'react';
import { PageLoader } from 'src/lib/PageLoader';

export const AsyncConsignmentSingleCollectorPage = ({ ...props }): JSX.Element => (
  <PageLoader
    id={'src/pages/ConsignmentNotableCollectors/ConsignmentSingleCollectorPage'}
    componentImport={async () => (await import('src/pages/ConsignmentNotableCollectors/ConsignmentSingleCollectorPage'))}
    head={() => async () => {
      return {
        title: 'Notable collector',
        description: 'More information about this Great Collector',
      };
    }}
    {...props}
  />
);
